import { Link } from "react-router-dom";
import { CardRowDetail, CardRowDetailColumn, CardRowDetailLine, CardRowDetailLineSpacer } from "widgets";

import { TrackEnum } from "../../../openapi";
import type { FeatureInfo, TrackType } from "../../../types.ts";
import { formatRegion } from "../../../utils/region.ts";
import { getEntityTypeFromTrackType } from "../../../utils/type-conversion.ts";

export const TrackNuFeatureTooltip = ({
  info,
  currentTrackType,
  contigName,
}: {
  info: FeatureInfo;
  currentTrackType: TrackType | undefined;
  contigName: string | undefined;
}) => (
  <CardRowDetail>
    <CardRowDetailColumn>
      <CardRowDetailLine title="Name">
        {!!currentTrackType && (
          <Link to={`/${getEntityTypeFromTrackType(TrackEnum.NUCLEOTIDE_FEATURE)}/${info?.id}`} target="_blank">
            <div style={{ wordWrap: "break-word", textWrap: "wrap", overflow: "hidden", maxWidth: "300px" }}>
              {info.name}
            </div>
          </Link>
        )}
      </CardRowDetailLine>
      {!!info.description && (
        <CardRowDetailLine title="Description" wrap>
          {info?.description}
        </CardRowDetailLine>
      )}
      <CardRowDetailLineSpacer />
      <CardRowDetailLine title="Region">
        {!!info.start && !!info.stop && formatRegion(contigName ?? info.name, info.start, info.stop)}
      </CardRowDetailLine>
      <CardRowDetailLine title="Length">
        {!!info.start && !!info.stop && `${(info.stop - info.start + 1).toLocaleString("en-US")} bp`}
      </CardRowDetailLine>
      <CardRowDetailLine title="Strand">{info.strand}</CardRowDetailLine>
      {!!info?.extReferences && info.extReferences.length > 0 && (
        <CardRowDetailLine title={"External References"} wrap>
          {info.extReferences.map((e, i) => (
            <div key={`feature-tooltips-row${i}`}>
              <a target="_blank" rel="noopener noreferrer" title={`Open link in new tab`} href={e.link}>
                {e.displayName}
              </a>
            </div>
          ))}
        </CardRowDetailLine>
      )}
    </CardRowDetailColumn>
  </CardRowDetail>
);
